function isValidDate(date: any) {
  return date instanceof Date && !isNaN(date as any)
}

export const calculateRelativeDate = (date: Date, locale: string): string => {
  if (!isValidDate(date as any)) {
    return date as unknown as string
  }

  const now = new Date()
  const lastModified = (date.getTime() - now.getTime()) / 1000

  const MINUTE = 60
  const HOUR = 60 * MINUTE
  const DAY = 24 * HOUR
  const WEEK = 7 * DAY
  const MONTH = 30 * DAY
  const YEAR = 365 * DAY

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  if (Math.abs(lastModified) < MINUTE) {
    // Less than 1 minute
    return rtf.format(Math.round(lastModified), 'second')
  } else if (Math.abs(lastModified) < HOUR) {
    // Less than 1 hour
    return rtf.format(Math.round(lastModified / MINUTE), 'minute')
  } else if (Math.abs(lastModified) < DAY) {
    // Less than 1 day
    return rtf.format(Math.round(lastModified / HOUR), 'hour')
  } else if (Math.abs(lastModified) < WEEK) {
    // Less than 1 week
    return rtf.format(Math.round(lastModified / DAY), 'day')
  } else if (Math.abs(lastModified) < MONTH) {
    // Less than 1 month
    return rtf.format(Math.round(lastModified / WEEK), 'week')
  } else if (Math.abs(lastModified) < YEAR) {
    // Less than 1 year
    return rtf.format(Math.round(lastModified / MONTH), 'month')
  } else {
    // 1 year or more
    return rtf.format(Math.round(lastModified / YEAR), 'year')
  }
}
